module.exports = __webpack_public_path__ + "img/1538210764.6a6906f8.jpg";